module.exports = __webpack_public_path__ + "img/ch4pic3.9803168b.png";